import { Box, Button, Link, Rating, Typography } from '@mui/material'
import React from 'react'
import { CommercialViabilityScore } from '../../../../models/startup'
import RingChart from '../../reusable/RingChart'

interface Props {
  userScore?: CommercialViabilityScore
  aggregateScore?: CommercialViabilityScore
  onScoreNowPressed: () => void
  onAllScoresPressed: () => void
}

const StartupScores = (props: Props) => {
  const aggregateData = props.aggregateScore?.question_group_scores.map((groupScore) => {
    return {
      label: groupScore.name,
      value: groupScore.score
    }
  }).sort((a, b) => {
    if (a.label < b.label) {
      return -1
    } else {
      return 1
    }
  }) || []

  const userData = props.userScore?.question_group_scores.map((groupScore) => {
    return {
      label: groupScore.name,
      value: groupScore.score
    }
  }).sort((a, b) => {
    if (a.label < b.label) {
      return -1
    } else {
      return 1
    }
  }) || []

  return (
    <Box display='flex' flexDirection='column' alignItems='center' sx={{
      width: '100%'
    }}>
      <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-around' sx={{
        width: '100%'
      }}>
        <Box display='flex' flexDirection='column' alignItems='center' sx={{
          m: 1
        }}>
          <Typography variant='body1' sx={{
            fontSize: '18px',
            padding: '12px'
          }}>Overall Ecliptic Score</Typography>
          {props.aggregateScore &&
            <RingChart data={aggregateData} diameter={80} />
          }
          <Link href='#' onClick={(e) => {
            e.preventDefault()
            props.onAllScoresPressed()
          }}>
            <Typography variant='h5' sx={{
              padding: '12px'
            }}>{props.aggregateScore?.score || '-' }</Typography>
          </Link>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' sx={{
          m: 1
        }}>
          <Typography variant='body1' sx={{
            fontSize: '18px',
            padding: '12px'
          }}>Your Score</Typography>
          {props.userScore &&
            <RingChart data={userData} diameter={80} />
          }
          <Typography variant='h5' sx={{
            padding: '12px'
          }}>{props.userScore?.score || '-'}</Typography>
          
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' sx={{
          m: 1
        }}>
          <Typography variant='body1' sx={{
            fontSize: '18px',
            padding: '12px'
          }}>Pitch Material Score</Typography>
          {props.aggregateScore &&
            <Rating 
              name='pitch-deck-quality' 
              precision={0.1} 
              readOnly 
              defaultValue={props.aggregateScore.pitch_deck_quality} />
          }
          {!props.aggregateScore &&
            <Typography variant='h5'>-</Typography>
          }
        </Box>
      </Box>
      {!props.aggregateScore &&
        <Button variant='contained' color='primary' onClick={props.onScoreNowPressed}>
          Score now to view all scores
        </Button>
      }
    </Box>
  )
}

export default StartupScores
